/**
 * JS oznámení o použití cookies na webu
 */

import { purposeDataEnum, FRAGMENTS, LEVEL, COOKIE_NAME } from './enums/enums';
import { renderPaneTemplate } from './templates/paneTemplate';
import { renderSettingsTemplate } from './templates/settingsTemplate';
//import { renderGTMTemplate } from './templates/renderGTMTemplate';
import { isEqual } from './utils/isEqual';
import { merge } from './utils/merge';
import motive from './img/motive.gif';

// eslint-disable-next-line no-unused-vars
const VERSION = '4.0.7';

export class CookiePolicy {

	static defaultProps = {
		activeAccordionClassName: 'cookies__accordion--active',
		activeSettingsClassName: 'cookies-settings--active',
		activeTabBtnClassName: 'cookies-settings__tab-button--active',
		activeTabContentClassName: 'cookies-settings__tab-content--active',
		disableRwdImg: true,
		disableRwdImgClassName: 'cookies-policy--disable-rwd-img',
		enableCloseButton: false,
		enableComplexGTM: false,
		enableIframe: false,
		enableImg: true,
		enableModal: false,
		enableModalClassName: 'cookies-policy--modal',
		enableOneGTMContainer: false,
		enableRenderModalFooterButtonsContainer: true,
		enableRenderModalFooterAcceptAllButton: false,
		enableRenderModalFooterAcceptSelectedButton: true,
		enableRenderModalFooterTechnicalButton: true,
		enableRenderModalHeaderButtonsContainer: true,
		enableSplitGTMContainer: false,
		enableTechnicalButton: true,
		excludedSelectors: [],
		hiddenPaneClassName: 'cookies-policy--hidden',
		idPane: 'cookies-policy-pane',
		idSettings: 'cookies-policy-settings',
		imgSrc: motive,
		jsonDataElementSelector: FRAGMENTS.JSON_DATA,
		jsonData: {},
		whiteListPurposeCheckbox: [],
		template: data => renderPaneTemplate(data),
		settingsTemplate: settingsData => renderSettingsTemplate(settingsData),
		container: 'body',
		cookieName: COOKIE_NAME.DEFAULT,
		recipientCookieName: COOKIE_NAME.RECIPIENT,
		cookieLifetime: 365,
		excludedCPClassName: 'js_hideCookiePolicy',
		//gtmCodeTemplate: gtmId => renderGTMTemplate(gtmId),
		position: 'bottom',
		handleButtonClick: () => {},
	};

	constructor(props) {

/*PDU		window.dataLayer = window.dataLayer || [];
		window.gtag = function () {
			window.dataLayer.push(arguments);
		};*/

		if (!navigator.cookieEnabled) {
			return false;
		}

		this.prevState = {};

		this.state = {
			acceptedCookieLevel: [],
			isPaneOpen: true,
			isSettingsOpen: false,
			purposeData: {
				[ purposeDataEnum.AD ]: false,
				[ purposeDataEnum.AD_ANALYTICS ]: false,
				[ purposeDataEnum.ANALYTICS ]: false,
			},
			recipientData: {},
		};

		this.props = this.constructor.defaultProps;
		this.props = merge(this.props, props);

		this.element = document.querySelector(this.props.container);

		this.objects = {};

		this.objects.isExcluded = false;
		if (this.props.excludedSelectors.length > 0) {
			this.isExcluded();
			if (this.objects.isExcluded) {
				return false;
			}
		}

		// Pokud nastane tahle kombinace props, ukončuje se a loguje chybu
		if (this.props.enableComplexGTM && this.props.enableSplitGTMContainer) {
			throw 'You can not use this combination of settings!';
		}

		this.objects.jsonData = {};
		this.objects.jsonData.messagePane = null;
		this.objects.jsonData.messageSettings = null;
		this.objects.jsonData.messageAccordion = null;
		this.objects.jsonData.recipientData = null;
		this.objects.acceptAllBtn = null;
		this.objects.closeBtn = null;
		this.objects.openSettingsBtn = null;
		this.objects.pane = null;
		this.objects.technicalBtn = null;
		this.objects.openPaneLinks = null;
		this.objects.openSettingsLinks = null;
		this.objects.settings = null;
		this.objects.settingsAcceptAllBtns = null;
		this.objects.settingsTechnicalBtn = null;
		this.objects.settingsClose = null;
		this.objects.settingsStateText = null;
		this.objects.settingsTabBtns = null;
		this.objects.settingsPurposeInputs = null;
		this.objects.settingsAccordionBtns = null;

		this.handleAcceptSelectedClick = this.handleAcceptSelectedClick.bind(this);
		this.handleCloseSettingsClick = this.handleCloseSettingsClick.bind(this);
		this.handleSubmitTechnicalLevel = this.handleSubmitTechnicalLevel.bind(this);
		this.handleSubmitAllLevels = this.handleSubmitAllLevels.bind(this);
		this.handleOpenPaneClick = this.handleOpenPaneClick.bind(this);
		this.handleOpenSettingsClick = this.handleOpenSettingsClick.bind(this);
		this.handleClosePolicyClick = this.handleClosePolicyClick.bind(this);
		this.handleTabClick = this.handleTabClick.bind(this);
		this.handleCheckboxPurposeChange = this.handleCheckboxPurposeChange.bind(this);
		this.handleCheckboxRecipientChange = this.handleCheckboxRecipientChange.bind(this);
		this.handleAccordionClick = this.handleAccordionClick.bind(this);

		this.init();
	}

	init() {
		/**
		 * Načtu si jsonData (lokalizační klíče, pokud používám CL v4 očekávám rozšiřující checkboxy)
		 */
		this.loadJsonData();

		// Nastav elementy - To je pouze pro odkazy / tlačítka s patřičným data atributem, který se nachází někde na webu a ne v CL template
		this.objects.openPaneLinks = this.element.querySelectorAll(FRAGMENTS.OPEN_PANE_LINK);
		this.objects.openSettingsLinks = this.element.querySelectorAll(FRAGMENTS.OPEN_SETTINGS_LINK);

		// Nejdříve odbinduju listenery, pokud již existují
		this.unbindUniversalEvents();
		// Nabinduju listenery - týká se hlavně tlačítka pro nastavení cookies, které můžou být na webu
		this.bindUniversalEvents();

		/**
		 * Načte Cookie a nasetuje její state
		 * Nasetuje PurposeState
		 * Nasetuje RecipientState
		 */
		this.setDataFromCookie();
	}

	loadJsonData() {
		const {
			enableComplexGTM,
			jsonData,
			jsonDataElementSelector,
		} = this.props;

		// Pokud existujou data v props, použiju props data, jinak si je nechám načíst z nějakého elementu v DOMU
		if (Object.keys(jsonData).length > 0) {
			if (jsonData) {
				this.objects.jsonData = jsonData;
			}
		} else {
			const loadedJsonData = document.querySelector(jsonDataElementSelector);
			if (loadedJsonData) {
				this.objects.jsonData = JSON.parse(loadedJsonData.innerHTML);
			}
		}
		if (enableComplexGTM && !this.objects.jsonData.recipientData) {
			throw 'Data for recipient checkboxes is missing in the json data!';
		}
	}

	setState(newState) {
		const prevState = this.state;
		this.prevState = prevState;

		this.state = {
			...this.state,
			...newState,
		};

		this.update(prevState);
	}

	// eslint-disable-next-line class-methods-use-this,no-unused-vars
	update(prevState) {
		const {
			acceptedCookieLevel,
			isPaneOpen,
			isSettingsOpen,
			purposeData,
			recipientData,
		} = this.state;

		const {
			acceptedCookieLevel: prevAcceptedCookieLevel,
			isPaneOpen: prevIsPaneOpen,
			isSettingsOpen: prevIsSettingsOpen,
			purposeData: prevPurposeData,
			recipientData: prevRecipientData,
		} = prevState;

/*PDU		if (!isEqual(acceptedCookieLevel, prevAcceptedCookieLevel)) {
			this.updateCookieLevel();
		}*/

		if (!isEqual(isPaneOpen, prevIsPaneOpen) || isPaneOpen) {
			this.updatePane();
			this.updateCheckbox(purposeData);
			this.updateCheckbox(recipientData);
		}

		if (!isEqual(isSettingsOpen, prevIsSettingsOpen)) {
			this.updateSettings();
			this.updateCheckbox(purposeData);
			this.updateCheckbox(recipientData);
		}

		if (!isEqual(purposeData, prevPurposeData)) {
			this.updateCheckbox(purposeData);
		}

		if (!isEqual(recipientData, prevRecipientData)) {
			this.updateCheckbox(recipientData);
		}
	}

	/**
	 * Odebírá / přidává do DOM GTM kontejnery
	 */
/*PDU	updateCookieLevel() {
		this.renderGTMContainer();
	}*/

	/**
	 * Skrývá / zobrazuje úvodní panel / modal
	 */
	updatePane() {
		const {
			isPaneOpen,
		} = this.state;

		const {
			hiddenPaneClassName,
		} = this.props;

		if (isPaneOpen) {
			// Pokud už existují nabindované listenery, tak je nejdříve odbinduju
			this.unbindPaneEvents();

			// Vyrenderuj panel / modal
			this.renderPane();

			// Nastav elementy
			this.objects.acceptAllBtn = this.element.querySelector(FRAGMENTS.ACCEPT_ALL_BTN);
			this.objects.pane = this.element.querySelector(FRAGMENTS.PANE);
			this.objects.closeBtn = this.element.querySelector(FRAGMENTS.CLOSE_BTN);
			this.objects.openSettingsBtn = this.element.querySelector(FRAGMENTS.OPEN_SETTINGS_BTN);
			this.objects.technicalBtn = this.element.querySelector(FRAGMENTS.TECHNICAL_BTN);

			// Abych mohl znovu zobrazit panel / modal, musím odebrat class
			this.objects.pane.classList.remove(hiddenPaneClassName);

			// Nabinduj Listenery
			this.bindPaneEvents();
		} else {
			/**
			 * Přidám active class
			 * Pomocí setTimeout, protože já nemám v DOM vyrenderované elementy, ty se renderují až na základě state
			 * Díky opožděnému přidání classy získám patřičnou animaci
			 */
			setTimeout(() => {
				if (this.objects.pane) {
					this.objects.pane.classList.add(hiddenPaneClassName);
				}
			}, 1);

			this.unbindPaneEvents();
		}
	}

	/**
	 * Skrývá / zobrazuje modal s nastavením
	 */
	updateSettings() {
		const {
			isSettingsOpen,
		} = this.state;

		const {
			activeSettingsClassName,
		} = this.props;

		if (isSettingsOpen) {
			// Pokud už existují nabindované listenery, tak je nejdříve odbinduju
			this.unbindSettingsEvents();

			// Vyrenderuj settings (modal s nastavením)
			this.renderSettings();

			// Nastav elementy
			this.objects.settings = this.element.querySelector(FRAGMENTS.SETTINGS);
			this.objects.settingsAcceptAllBtns = this.element.querySelectorAll(FRAGMENTS.SETTINGS_ACCEPT_ALL_BTN);
			this.objects.settingsAcceptSelectedBtn = this.element.querySelector(FRAGMENTS.SETTINGS_ACCEPT_SELECTED_BTN);
			this.objects.settingsTechnicalBtn = this.element.querySelector(FRAGMENTS.SETTINGS_TECHNICAL_BTN);
			this.objects.settingsStateText = this.element.querySelector(FRAGMENTS.SETTINGS_STATE_TEXT);
			this.objects.settingsClose = this.element.querySelector(FRAGMENTS.SETTINGS_CLOSE_BTN);
			this.objects.settingsTabBtns = this.element.querySelectorAll(FRAGMENTS.TAB_BTN);
			this.objects.settingsPurposeInputs = this.objects.settings.querySelectorAll(FRAGMENTS.SETTINGS_PURPOSE_INPUT);
			this.objects.settingsRecipientInputs = this.objects.settings.querySelectorAll(FRAGMENTS.SETTINGS_RECIPIENT_INPUT);
			this.objects.settingsAccordionBtns = this.objects.settings.querySelectorAll(FRAGMENTS.ACCORDION_BTN);

			// Nabinduj Listenery
			this.bindSettingsEvents();

			/**
			 * Přidám active class
			 * Pomocí setTimeout, protože já nemám v DOM vyrenderované elementy, ty se renderují až na základě state
			 * Díky opožděnému přidání classy získám patřičnou animaci
			 */
			setTimeout(() => {
				if (this.objects.settings) {
					this.objects.settings.classList.add(activeSettingsClassName);
				}
			}, 1);
		} else {
			if (this.objects.settings) {
				this.objects.settings.classList.remove(activeSettingsClassName);
			}
			this.unbindSettingsEvents();
		}
	}

	/**
	 * Mění stav a textace checkboxu
	 */
	updateCheckbox(data) {
		Object.entries(data)
			.forEach(([ key, value ]) => {
				const inputElement = this.element.querySelector(`input[name="${ key }"]`);
				if (inputElement) {
					const checkboxText = inputElement.parentNode.querySelector(FRAGMENTS.SETTINGS_STATE_TEXT);
					if (checkboxText) {
						if (value) {
							inputElement.checked = true;
							checkboxText.innerText = this.objects.jsonData.messageSettings.checkboxStateOn;
						} else {
							inputElement.checked = false;
							checkboxText.innerText = this.objects.jsonData.messageSettings.checkboxStateOff;
						}
					}
				}
			});
	}

	/**
	 * Přidává panel do DOM na určenou pozici
	 */
	renderPane() {
		const {
			position,
		} = this.props;

		if (!this.element.querySelector(FRAGMENTS.PANE)) {
			const pane = this.buildPaneCode();

			if (position === 'bottom') {
				this.element.insertAdjacentHTML('beforeend', pane);
			} else {
				this.element.insertAdjacentHTML('afterbegin', pane);
			}
		}
	}

	/**
	 * Přidává modal s nastavením do DOM na určenou pozici
	 */
	renderSettings() {
		const {
			position,
		} = this.props;

		if (!this.element.querySelector(FRAGMENTS.SETTINGS)) {
			const settings = this.buildSettingsCode();

			// Pokud ještě není v DOM vyrenderovaný obsah pro settigs, tak ho vyrenderuj
			if (position === 'bottom') {
				this.element.insertAdjacentHTML('beforeend', settings);
			} else {
				this.element.insertAdjacentHTML('afterbegin', settings);
			}
		}
	}

	bindUniversalEvents() {
		if (this.objects.openPaneLinks) {
			[ ...this.objects.openPaneLinks ].map(openPaneLink => openPaneLink.addEventListener('click', this.handleOpenPaneClick));
		}

		if (this.objects.openSettingsLinks) {
			[ ...this.objects.openSettingsLinks ].map(openSettingsLink => openSettingsLink.addEventListener('click', this.handleOpenSettingsClick));
		}
	}

	unbindUniversalEvents() {
		if (this.objects.openPaneLinks) {
			[ ...this.objects.openPaneLinks ].map(openPaneLink => openPaneLink.removeEventListener('click', this.handleOpenPaneClick));
		}

		if (this.objects.openSettingsLinks) {
			[ ...this.objects.openSettingsLinks ].map(openSettingsLink => openSettingsLink.removeEventListener('click', this.handleOpenSettingsClick));
		}
	}

	bindPaneEvents() {
		if (this.objects.acceptAllBtn) {
			this.objects.acceptAllBtn.addEventListener('click', this.handleSubmitAllLevels);
		}

		if (this.objects.closeBtn) {
			this.objects.closeBtn.addEventListener('click', this.handleClosePolicyClick);
		}

		if (this.objects.openSettingsBtn) {
			this.objects.openSettingsBtn.addEventListener('click', this.handleOpenSettingsClick);
		}

		if (this.objects.technicalBtn) {
			this.objects.technicalBtn.addEventListener('click', this.handleSubmitTechnicalLevel);
		}
	}

	unbindPaneEvents() {
		if (this.objects.acceptAllBtn) {
			this.objects.acceptAllBtn.removeEventListener('click', this.handleSubmitAllLevels);
		}

		if (this.objects.closeBtn) {
			this.objects.closeBtn.removeEventListener('click', this.handleClosePolicyClick);
		}

		if (this.objects.openSettingsBtn) {
			this.objects.openSettingsBtn.removeEventListener('click', this.handleOpenSettingsClick);
		}

		if (this.objects.technicalBtn) {
			this.objects.technicalBtn.removeEventListener('click', this.handleSubmitTechnicalLevel);
		}
	}

	bindSettingsEvents() {
		if (this.objects.settingsAcceptAllBtns) {
			[ ...this.objects.settingsAcceptAllBtns ].map(settingsAcceptAllBtn => settingsAcceptAllBtn.addEventListener('click', this.handleSubmitAllLevels));
		}

		if (this.objects.settingsClose) {
			this.objects.settingsClose.addEventListener('click', this.handleCloseSettingsClick);
		}

		if (this.objects.settingsTechnicalBtn) {
			this.objects.settingsTechnicalBtn.addEventListener('click', this.handleSubmitTechnicalLevel);
		}

		if (this.objects.settingsAcceptSelectedBtn) {
			this.objects.settingsAcceptSelectedBtn.addEventListener('click', this.handleAcceptSelectedClick);
		}

		if (this.objects.settingsTabBtns) {
			[ ...this.objects.settingsTabBtns ].map(settingsTabBtn => settingsTabBtn.addEventListener('click', this.handleTabClick));
		}

		if (this.objects.settingsPurposeInputs) {
			[ ...this.objects.settingsPurposeInputs ].map(settingsPurposeInput => settingsPurposeInput.addEventListener('change', this.handleCheckboxPurposeChange));
		}

		if (this.objects.settingsRecipientInputs) {
			[ ...this.objects.settingsRecipientInputs ].map(settingsRecipientInput => settingsRecipientInput.addEventListener('change', this.handleCheckboxRecipientChange));
		}

		if (this.objects.settingsAccordionBtns) {
			[ ...this.objects.settingsAccordionBtns ].map(settingsAccordionBtn => settingsAccordionBtn.addEventListener('click', this.handleAccordionClick));
		}
	}

	unbindSettingsEvents() {
		if (this.objects.settingsAcceptAllBtns) {
			[ ...this.objects.settingsAcceptAllBtns ].map(settingsAcceptAllBtn => settingsAcceptAllBtn.removeEventListener('click', this.handleSubmitAllLevels));
		}

		if (this.objects.settingsClose) {
			this.objects.settingsClose.removeEventListener('click', this.handleCloseSettingsClick);
		}

		if (this.objects.settingsTechnicalBtn) {
			this.objects.settingsTechnicalBtn.removeEventListener('click', this.handleSubmitTechnicalLevel);
		}

		if (this.objects.settingsAcceptSelectedBtn) {
			this.objects.settingsAcceptSelectedBtn.removeEventListener('click', this.handleAcceptSelectedClick);
		}

		if (this.objects.settingsTabBtns) {
			[ ...this.objects.settingsTabBtns ].map(settingsTabBtn => settingsTabBtn.removeEventListener('click', this.handleTabClick));
		}

		if (this.objects.settingsPurposeInputs) {
			[ ...this.objects.settingsPurposeInputs ].map(settingsPurposeInput => settingsPurposeInput.removeEventListener('change', this.handleCheckboxPurposeChange));
		}

		if (this.objects.settingsRecipientInputs) {
			[ ...this.objects.settingsRecipientInputs ].map(settingsRecipientInput => settingsRecipientInput.removeEventListener('change', this.handleCheckboxRecipientChange));
		}

		if (this.objects.settingsAccordionBtns) {
			[ ...this.objects.settingsAccordionBtns ].map(settingsAccordionBtn => settingsAccordionBtn.removeEventListener('click', this.handleAccordionClick));
		}
	}

	/**
	 * Najdu si požadovanou cookie, přečtu si její stav a nasetuju si state
	 */
	setDataFromCookie() {
		// Načtu cookie
		const acceptedCookieLevel = this.getCookie(this.props.cookieName);
		// Vrátím isPaneOpen state
		const isPaneOpen = this.loadIsPaneOpen(acceptedCookieLevel);
		// Vrátím purpose state
		const purposeData = this.loadPurposeData(acceptedCookieLevel);
		// Vratím recipient state
		const recipientData = this.loadRecipientData(purposeData);

		this.setState({
			isPaneOpen,
			acceptedCookieLevel,
			purposeData,
			recipientData,
		});
	}

	loadIsPaneOpen(acceptedCookieLevel) {
		const {
			excludedCPClassName,
		} = this.props;

		let isPaneOpen;

		// Pokud najdu číslo 2 v poli, to znamená, že uživatel již v minulosti souhlasil s cookies tak chci CL schovat
		isPaneOpen = ![ ...acceptedCookieLevel ].some(value => value === LEVEL.TECHNICAL);

		if (this.element.classList.contains(excludedCPClassName)) {
			this.element.classList.remove(excludedCPClassName);
			isPaneOpen = false;
		}

		return isPaneOpen;
	}

	/**
	 * Nasetuju si recipientState pro checkboxy
	 */
	loadRecipientData(purposeData) {
		const {
			enableComplexGTM,
		} = this.props;

		let newRecipientData = {
			...this.state.recipientData,
		};

		// Pouze pokud mám zapnutou props
		if (enableComplexGTM) {
			const {
				recipientData,
			} = this.objects.jsonData;

			const recipientCookieData = this.getCookie(this.props.recipientCookieName);
			let isArrayEmpty = false;

			if (recipientCookieData) {
				// Pokud najdu v poli -1 nebo prázdný string, tak si uložím true
				isArrayEmpty = [ ...recipientCookieData ].some(item => item === -1 || item === '');
			}

			// Pomocná vnitřní funkce pro nastavování recipient checkboxů
			const setRecipientCheckboxManually = (levelNumber, isTrue) => {
				const filteredRecipientData = Object.fromEntries(Object.entries(recipientData).filter(([ key, { level } ]) => level === levelNumber));
				Object.keys(filteredRecipientData).forEach((item) => {
					newRecipientData = {
						...newRecipientData,
						[ item ]: isTrue,
					};
				});
			};

			if (recipientData) {
				// Jestliže jsem neměl ještě CL v4 zapnutou, nemám data a tak chci nastavit state pro recipient chekcboxy
				if (isArrayEmpty) {
					// Pokud mám v recipient datech Level 2, tak chci nasetovat jeho checkbox na true
					const filteredRecipientData = Object.fromEntries(Object.entries(recipientData).filter(([ key, { level } ]) => level === 2));
					Object.keys(filteredRecipientData).forEach((item) => {
						newRecipientData = {
							...newRecipientData,
							[ item ]: true,
						};
					});
					Object.entries(purposeData).forEach(([ key, value ]) => {
						switch (key) {
							case purposeDataEnum.AD:
								setRecipientCheckboxManually(LEVEL.AD, value);
								break;
							case purposeDataEnum.ANALYTICS:
								setRecipientCheckboxManually(LEVEL.ANALYTICS, value);
								break;
							case purposeDataEnum.FUNCTIONALITY:
								setRecipientCheckboxManually(LEVEL.FUNCTIONALITY, value);
								break;
							case purposeDataEnum.PERSONALIZATION:
								setRecipientCheckboxManually(LEVEL.PERSONALIZATION, value);
								break;
							case purposeDataEnum.SECURITY:
								setRecipientCheckboxManually(LEVEL.SECURITY, value);
								break;
							default:
								break;
						}
					});
				} else {
					// Načtu si data z jsonu a na jejich základě porovnávám s daty v cookie a podle vyhodnocené podmínky nastavuji state
					Object.keys(recipientData).forEach((data) => {
						const isFounded = [ ...recipientCookieData ].some(cookieData => cookieData === data);
						newRecipientData = {
							...newRecipientData,
							[ data ]: isFounded,
						};
					});
				}
			}
		}

		return {
			...newRecipientData,
		};
	}

	/**
	 * Nasetuju si purposeState pro checkboxy
	 */
	loadPurposeData(cookieLevel) {
		const {
			whiteListPurposeCheckbox,
		} = this.props;

		let cookieData = {
			...this.state.purposeData,
		};

		// Pokud chci přidat další checkboxy, než je Analyticky a Marketingový, tak tady nastavuji default state
		[ ...whiteListPurposeCheckbox ].forEach((item) => {
			switch (item) {
				case purposeDataEnum.FUNCTIONALITY:
					cookieData = {
						...cookieData,
						[ purposeDataEnum.FUNCTIONALITY ]: false,
					};
					break;
				case purposeDataEnum.PERSONALIZATION:
					cookieData = {
						...cookieData,
						[ purposeDataEnum.PERSONALIZATION ]: false,
					};
					break;
				case purposeDataEnum.SECURITY:
					cookieData = {
						...cookieData,
						[ purposeDataEnum.SECURITY ]: false,
					};
					break;
				default:
					break;
			}
		});

		cookieLevel.forEach((level) => {
			switch (level) {
				case LEVEL.ANALYTICS:
					cookieData = {
						...cookieData,
						[ purposeDataEnum.ANALYTICS ]: true,
					};
					break;
				case LEVEL.AD:
					cookieData = {
						...cookieData,
						[ purposeDataEnum.AD ]: true,
					};
					break;
				case LEVEL.AD_ANALYTICS:
					cookieData = {
						...cookieData,
						[ purposeDataEnum.AD ]: true,
						[ purposeDataEnum.ANALYTICS ]: true,
						[ purposeDataEnum.AD_ANALYTICS ]: true,
					};
					break;
				case LEVEL.FUNCTIONALITY:
					cookieData = {
						...cookieData,
						[ purposeDataEnum.FUNCTIONALITY ]: true,
					};
					break;
				case LEVEL.PERSONALIZATION:
					cookieData = {
						...cookieData,
						[ purposeDataEnum.PERSONALIZATION ]: true,
					};
					break;
				case LEVEL.SECURITY:
					cookieData = {
						...cookieData,
						[ purposeDataEnum.SECURITY ]: true,
					};
					break;
				default:
					break;
			}
		});

		return {
			...cookieData,
		};
	}

	/**
	 * Obsluha spřaženého checkboxu AD a Analytického
	 */
	adAnalyticsPurposeState(purposeData) {
		const {
			ad,
			adAnalytics,
			analytics,
		} = purposeData;

		const {
			enableComplexGTM,
			enableSplitGTMContainer,
		} = this.props;

		let newPurposeData = {
			...purposeData,
		};

		// Pokud je props true
		if (enableComplexGTM || enableSplitGTMContainer) {
			// Pokud je ad state nebo analytics state false tak chci, aby případný spřažený checkbox AD_ANALYTICS, byl také false, jinak bude true
			// To je pro případ, kdyby někdo měnil nastavení CL z jednoduché na složitější layout nebo obráceně
			if (!ad || !analytics) {
				newPurposeData = {
					...newPurposeData,
					[ purposeDataEnum.AD_ANALYTICS ]: false,
				};
			} else {
				newPurposeData = {
					...newPurposeData,
					[ purposeDataEnum.AD_ANALYTICS ]: true,
				};
			}
		} else if (!adAnalytics) {
			newPurposeData = {
				...newPurposeData,
				[ purposeDataEnum.AD ]: false,
				[ purposeDataEnum.ANALYTICS ]: false,
			};
		}

		return {
			...newPurposeData,
		};
	}

	/**
	 * Přepínání stavů pro purpose checkboxy
	 */
	handleCheckboxPurposeChange({
		target: {
			checked,
			value,
		},
	}) {
		const {
			enableComplexGTM,
		} = this.props;

		const {
			recipientData,
		} = this.objects.jsonData;

		let newPurposeData = {
			...this.state.purposeData,
			[ value ]: checked,
		};

		let newRecipientData = {
			...this.state.recipientData,
		};

		// Alias pro checkbox, který jsem kliknul, abych měl pak jak porovnávat data
		if (enableComplexGTM) {
			let checkboxLevel;
			switch (value) {
				case purposeDataEnum.AD:
					checkboxLevel = LEVEL.AD;
					break;
				case purposeDataEnum.ANALYTICS:
					checkboxLevel = LEVEL.ANALYTICS;
					break;
				case purposeDataEnum.FUNCTIONALITY:
					checkboxLevel = LEVEL.FUNCTIONALITY;
					break;
				case purposeDataEnum.PERSONALIZATION:
					checkboxLevel = LEVEL.PERSONALIZATION;
					break;
				case purposeDataEnum.SECURITY:
					checkboxLevel = LEVEL.SECURITY;
					break;
				default:
					break;
			}

			// Pokud checkbox (alias) si nese stejnou hodnotu, jako některý checkbox (level) z dat, tak chci všechny (se stejným levelem) checkboxy přepnout na patřičnou hodnotu
			Object.entries(recipientData).forEach(([ key, { level } ]) => {
				if (checkboxLevel === level) {
					newRecipientData = {
						...newRecipientData,
						[ key ]: checked,
					};
				}
			});
		}

		// Pouští se pouze po kliknutí na checkbox Analytics nebo Marketing
		if (value === purposeDataEnum.AD || value === purposeDataEnum.ANALYTICS || value === purposeDataEnum.AD_ANALYTICS) {
			const returnedPurposeData = this.adAnalyticsPurposeState(newPurposeData);
			newPurposeData = {
				...newPurposeData,
				...returnedPurposeData,
			};
		}

		this.setState({
			purposeData: newPurposeData,
			recipientData: newRecipientData,
		});
	}

	/**
	 * Přepínání stavů pro recipient checkboxy
	 */
	handleCheckboxRecipientChange({
		target: {
			checked,
			value,
		},
	}) {
		const {
			recipientData,
		} = this.objects.jsonData;

		let purposeData = {
			...this.state.purposeData,
		};

		const checkboxLevel = Object.entries(recipientData)
			.find(([ recipientKey, recipientValue ]) => recipientKey === value)
			.find(({ level }) => level)
			.level;

		const newRecipientData = {
			...this.state.recipientData,
			[ value ]: checked,
		};

		// Pokud checkbox (alias) si nese stejnou hodnotu, jako některý checkbox (level) z dat, tak chci všechny (se stejným levelem) checkboxy přepnout na patřičnou hodnotu
		const filteredLevel = Object.fromEntries(Object.entries(recipientData).filter(([ key, { level } ]) => checkboxLevel === level));
		const filteredCheckboxes = Object.keys(filteredLevel).filter(levelKey => Object.entries(newRecipientData).find(([ recipientKey, recipientValue ]) => (levelKey === recipientKey && recipientValue === true)));

		// Pomocná vnitřní funkce pro nastavení purposeState
		const setPurposeData = (value) => {
			switch (checkboxLevel) {
				case LEVEL.ANALYTICS:
					purposeData = {
						...purposeData,
						[ purposeDataEnum.ANALYTICS ]: value,
					};
					break;
				case LEVEL.AD:
					purposeData = {
						...purposeData,
						[ purposeDataEnum.AD ]: value,
					};
					break;
				case LEVEL.FUNCTIONALITY:
					purposeData = {
						...purposeData,
						[ purposeDataEnum.FUNCTIONALITY ]: value,
					};
					break;
				case LEVEL.PERSONALIZATION:
					purposeData = {
						...purposeData,
						[ purposeDataEnum.PERSONALIZATION ]: value,
					};
					break;
				case LEVEL.SECURITY:
					purposeData = {
						...purposeData,
						[ purposeDataEnum.SECURITY ]: value,
					};
					break;
				default:
					break;
			}
		};

		// Pokud ve vyfiltrovaném poli něco najdu, tak potom nastavím purposeState pro danný checkbox na true, když tam nic nebude tak nastavím state na false
		if (filteredCheckboxes.length > 0) {
			setPurposeData(true);
		} else {
			setPurposeData(false);
		}

		// Když budu mít rozpojený analyticky a marketingový checkbox tak vrať false
		const isAdAnalytics = !Object.entries(purposeData).find(([ key, value ]) => ((key === purposeDataEnum.ANALYTICS || key === purposeDataEnum.AD) && (value === false)));


		let newPurposeData = {
			...purposeData,
		};

		// Pokud je false - tudíš rozpojený checkbox analyticky a marketingový, tak nastav adAnalytics state na false, jinak true
		if (!isAdAnalytics) {
			newPurposeData = {
				...newPurposeData,
				[ purposeDataEnum.AD_ANALYTICS ]: false,
			};
		} else {
			newPurposeData = {
				...newPurposeData,
				[ purposeDataEnum.AD_ANALYTICS ]: true,
			};
		}

		this.setState({
			purposeData: newPurposeData,
			recipientData: newRecipientData,
		});
	}

	/**
	 * Nastavení technického levelu
	 */
	handleSubmitTechnicalLevel(e) {
		e.preventDefault();

		const {
			purposeData,
		} = this.state;

		const {
			enableComplexGTM,
		} = this.props;

		const {
			recipientData,
		} = this.objects.jsonData;

		let newRecipientData = {
			...this.state.recipientData,
		};

		let newPurposeData = {
			...purposeData,
		};

		Object.keys(purposeData).forEach((item) => {
			newPurposeData = {
				...newPurposeData,
				[ item ]: false,
			};
		});

		if (enableComplexGTM) {
			// Odfiltruju technické cookies z jsonDat / recipientData
			const filteredRecipientData = Object.fromEntries(Object.entries(recipientData).filter(([ key, value ]) => value.level !== 2));
			Object.keys(filteredRecipientData).forEach((item) => {
				newRecipientData = {
					...newRecipientData,
					[ item ]: false,
				};
			});
		}

		this.setState({
			purposeData: newPurposeData,
			recipientData: newRecipientData,
		});

		this.submitLevels();
	}

	/**
	 * Nastavení všech purpose levelů
	 */
	handleSubmitAllLevels() {
		const {
			purposeData,
		} = this.state;

		const {
			enableComplexGTM,
		} = this.props;

		const {
			recipientData,
		} = this.objects.jsonData;


		let newRecipientData = {
			...this.state.recipientData,
		};

		let newPurposeData = {
			...purposeData,
		};

		Object.keys(purposeData).forEach((item) => {
			newPurposeData = {
				...newPurposeData,
				[ item ]: true,
			};
		});

		if (enableComplexGTM) {
			Object.keys(recipientData).forEach((item) => {
				newRecipientData = {
					...newRecipientData,
					[ item ]: true,
				};
			});
		}

		this.setState({
			purposeData: newPurposeData,
			recipientData: newRecipientData,
		});

		this.submitLevels();
	}

	/**
	 * Nastavení Purpose levelů
	 */
	submitPurposeLevel() {
		const {
			purposeData,
		} = this.state;

		// Vždy bude technický level a k němu se budou připojovat další leveli na základě vyhodnocení níže
		const cookieLevel = [ LEVEL.TECHNICAL ];
		// Chci vyfiltrovaný objekt purpose checkboxů, které jsou true
		const filteredPurposeData = Object.fromEntries(Object.entries(purposeData).filter(([ key, value ]) => value === true));

		// Pokud je splněná podmínka, pushnu do pole
		Object.keys(filteredPurposeData).forEach((key) => {
			switch (key) {
				case purposeDataEnum.AD:
					cookieLevel.push(LEVEL.AD);
					break;
				case purposeDataEnum.AD_ANALYTICS:
					cookieLevel.push(LEVEL.AD);
					cookieLevel.push(LEVEL.AD_ANALYTICS);
					cookieLevel.push(LEVEL.ANALYTICS);
					break;
				case purposeDataEnum.ANALYTICS:
					cookieLevel.push(LEVEL.ANALYTICS);
					break;
				case purposeDataEnum.FUNCTIONALITY:
					cookieLevel.push(LEVEL.FUNCTIONALITY);
					break;
				case purposeDataEnum.PERSONALIZATION:
					cookieLevel.push(LEVEL.PERSONALIZATION);
					break;
				case purposeDataEnum.SECURITY:
					cookieLevel.push(LEVEL.SECURITY);
					break;
				default:
					break;
			}
		});

		// Odeberu případné duplicity z pole
		const removeDuplicities = [ ...new Set(cookieLevel) ];
		// Seřadím si pole
		const newCookieLevel = removeDuplicities.sort();

		this.setCookie(newCookieLevel);

		return newCookieLevel;
	}

	/**
	 * Nastavení Recipient levelů
	 */
	submitRecipientLevel() {
		const {
			recipientData,
		} = this.state;

		const {
			recipientCookieName,
		} = this.props;

		const recipientLevel = [];
		// Odfiltruju si pouze checkboxy, které jsou true
		const filteredRecipientData = Object.fromEntries(Object.entries(recipientData).filter(([ key, value ]) => value === true));
		// Projdu vyfiltrované pole a pushnu si do připraveného pole
		Object.keys(filteredRecipientData).map(item => recipientLevel.push(item));
		// Odeberu případné duplicity z pole
		const removeDuplicities = [ ...new Set(recipientLevel) ];
		// Seřadím si pole
		const newRecipientLevel = removeDuplicities.sort();

		this.setCookie(newRecipientLevel, recipientCookieName);
	}

	/**
	 * Klíčová funkce pro ukládání do Cookies
	 * Nastavuje purposeLevel a v případě zapnuté props i recipientLevel
	 * Vystřelí GTM push do Analytiky
	 * Nastavení nových stavů
	 * Možnost volání dodatečné handleButtonClick funkce z venku
	 */
	submitLevels() {
		const {
			enableComplexGTM,
		} = this.props;

		// Vrátí purposeLevel / cookieLevel
		const acceptedCookieLevel = this.submitPurposeLevel();

		if (enableComplexGTM) {
			this.submitRecipientLevel();
		}

		//PDU this.pushStateToGTM();

		this.setState({
			acceptedCookieLevel,
			isPaneOpen: false,
			isSettingsOpen: false,
		});

		// Možnost volání click akce z venku, aplikuje se na všechny tlačítka
		this.onClick();
	}

	onClick() {
		this.props.handleButtonClick();
	}

	/**
	 * Poslání cookieLevelu pomocné funkci, která zpracovává data na základě vybraných checkboxů v modalu s nastavením cookies
	 */
	handleAcceptSelectedClick(e) {
		e.preventDefault();
		this.submitLevels();
	}

	handleOpenPaneClick(e) {
		e.preventDefault();

		this.openPane();
	}

	openPane() {
		this.setState({
			isPaneOpen: true,
		});
	}

	handleOpenSettingsClick(e) {
		e.preventDefault();

		this.openSettings();
	}

	openSettings() {
		this.setState({
			isSettingsOpen: true,
		});
	}

	handleCloseSettingsClick() {
		this.setState({
			isSettingsOpen: false,
		});
	}

	handleClosePolicyClick() {
		this.setState({
			isPaneOpen: false,
		});
	}

	handleTabClick({ target }) {
		const {
			activeTabBtnClassName,
			activeTabContentClassName,
		} = this.props;

		const {
			settingsTabBtns,
		} = this.objects;

		const tabContentElement = this.element.querySelector(`#${ target.dataset.target }`);
		[ ...settingsTabBtns ].forEach((settingsTabBtn) => {
			const tabContentElement = this.element.querySelector(`#${ settingsTabBtn.dataset.target }`);
			settingsTabBtn.classList.remove(activeTabBtnClassName);
			tabContentElement.classList.remove(activeTabContentClassName);
		});

		target.classList.add(activeTabBtnClassName);
		tabContentElement.classList.add(activeTabContentClassName);
	}

	handleAccordionClick({ target }) {
		const {
			activeAccordionClassName,
		} = this.props;

		if (target.parentNode.classList.contains(activeAccordionClassName)) {
			target.parentNode.classList.remove(activeAccordionClassName);
		} else {
			target.parentNode.classList.add(activeAccordionClassName);
		}
	}

	/**
	 * Data pro panel / modal
	 */
	buildPaneCode() {
		return this.props.template({
			idPane: this.props.idPane,
			imgSrc: this.props.imgSrc,
			enableCloseBtn: this.props.enableCloseButton,
			enableImg: this.props.enableImg,
			enableTechnicalBtn: this.props.enableTechnicalButton,
			disableRwdImg: this.props.disableRwdImg && this.props.enableImg ? this.props.disableRwdImgClassName : '',
			enableModal: this.props.enableModal ? this.props.enableModalClassName : '',
			...this.objects.jsonData,
		});
	}

	/**
	 * Data pro modal s nastavením cookies
	 */
	buildSettingsCode() {
		return this.props.settingsTemplate({
			idSettings: this.props.idSettings,
			enableSplitGTMContainer: this.props.enableSplitGTMContainer,
			enableComplexGTM: this.props.enableComplexGTM,
			enableRenderModalFooterButtonsContainer: this.props.enableRenderModalFooterButtonsContainer,
			enableRenderModalFooterAcceptAllButton: this.props.enableRenderModalFooterAcceptAllButton,
			enableRenderModalFooterAcceptSelectedButton: this.props.enableRenderModalFooterAcceptSelectedButton,
			enableRenderModalFooterTechnicalButton: this.props.enableRenderModalFooterTechnicalButton,
			enableRenderModalHeaderButtonsContainer: this.props.enableRenderModalHeaderButtonsContainer,
			whiteListPurposeCheckbox: this.props.whiteListPurposeCheckbox,
			...this.objects.jsonData,
		});
	}

	/**
	 * Získání cookie
	 */
	getCookie(cookieName = this.props.cookieName) {
		const match = document.cookie.match(new RegExp(`${ cookieName }=([^;]+)`));

		if (match) {
			// Pokud existuje pole v cookie, tak odeber zavorky, splitni, vrať data a přeulož cookie
			if (match[ 1 ].includes('[')) {
				const returnedValue = match[ 1 ]
					.replace('[', '')
					.replace(']', '')
					.split(',')
					.map(item => cookieName === this.props.cookieName ? Number(item) : item);

				this.setCookie(returnedValue, cookieName);
				return returnedValue;
			}

			return match[ 1 ]
				.split('|')
				.map(item => cookieName === this.props.cookieName ? Number(item) : item);
		}

		return [ -1 ];
	}

	/**
	 * Nastavení cookie
	 */
	setCookie(cookieValue, cookieName = this.props.cookieName) {
		const {
			cookieLifetime,
			enableIframe,
		} = this.props;

		const d = new Date();
		const expires = new Date(d.setTime(d.getTime() + (cookieLifetime * 24 * 60 * 60 * 1000)));
		const lifetime = (cookieLifetime > 0) ? `;expires=${ expires.toUTCString() }` : '';
		const secure = window.location.protocol === 'https:' ? ';secure' : '';
		const sameSiteNone = window.location.protocol === 'https:' ? ';SameSite=None' : '';

		document.cookie = `${ cookieName }=${ cookieValue.toString().replaceAll(',', '|') }${ lifetime };path=/${ secure }${ enableIframe ? sameSiteNone : '' }`;
	}

	/**
	 * GTM Purpose push
	 */
	pushPurposeStateToGTM() {
		const {
			enableComplexGTM,
		} = this.props;

		const {
			ad,
			adAnalytics,
			analytics,
			functionality,
			personalization,
			security,
		} = this.state.purposeData;

		return {
			security_storage: (security || !enableComplexGTM) ? 'granted' : 'denied',
			functionality_storage: (functionality || !enableComplexGTM) ? 'granted' : 'denied',
			personalization_storage: (personalization || !enableComplexGTM) ? 'granted' : 'denied',
			analytics_storage: (analytics || adAnalytics) ? 'granted' : 'denied',
			ad_storage: (ad || adAnalytics) ? 'granted' : 'denied',
		};
	}

	/**
	 * GTM Recipient push
	 */
	pushRecipientStateToGTM() {
		const {
			recipientData,
		} = this.state;

		let level;

		Object.entries(recipientData).forEach(([ key, value ]) => {
			level = {
				...level,
				[ `${ key }_storage` ]: (value) ? 'granted' : 'denied',
			};
		});

		return level;
	}

	pushStateToGTM() {
		const {
			enableComplexGTM,
		} = this.props;

		const purposeLevel = this.pushPurposeStateToGTM();
		let recipientLevel = {};

		if (enableComplexGTM) {
			recipientLevel = this.pushRecipientStateToGTM();
		}

		const level = {
			...purposeLevel,
			...recipientLevel,
		};

		window.gtag('consent', 'update', level);
		dataLayer.push({
			event: 'consent_update',
			consent: level,
		});
	}

	/**
	 * Render GTM kontejnerů
	 */
	renderGTMContainer() {
		const {
			ad,
			adAnalytics,
			analytics,
		} = this.state.purposeData;

		const {
			enableComplexGTM,
			enableOneGTMContainer,
			enableSplitGTMContainer,
		} = this.props;

		if (enableOneGTMContainer || enableComplexGTM) return;

		const dataAttribute = 'data-cookies-policy-identifier';
		/**
		 * Analytics kontejner se vyrenderuje pouze, když cookie level je 3 nebo 5
		 * a zároveň musí být props `enableSplitGTMContainer` na true
		 */
		const gtmAnalyticsId = document.documentElement.dataset.gtmAnalytics;
		const gtmAnalyticsScript = document.createElement('script');
		gtmAnalyticsScript.setAttribute(dataAttribute, purposeDataEnum.ANALYTICS);
		const isExistAnalyticsScript = document.querySelector(`script[${ dataAttribute }="${ purposeDataEnum.ANALYTICS }"]`);

		if ((analytics || adAnalytics) && (enableSplitGTMContainer)) {
			if (gtmAnalyticsId && gtmAnalyticsId !== '!NOTSET!') {
				if (!isExistAnalyticsScript) {
					gtmAnalyticsScript.text = this.props.gtmCodeTemplate(gtmAnalyticsId);
					document.body.appendChild(gtmAnalyticsScript);
				}
			} else {
				console.error('GTM container for analytics tags is not set!');
			}
		} else if (isExistAnalyticsScript) {
			isExistAnalyticsScript.remove();
		}

		/**
		 * Marketing kontejner se vyrenderuje pouze, když cookie level je 4 nebo 5
		 * a když to bude cokoliv jiného a bude existovat z dřívějška tak ho chci odebrat
		 */
		const gtmMarketingId = document.documentElement.dataset.gtmMarketing;
		const gtmMarketingScript = document.createElement('script');
		gtmMarketingScript.setAttribute(dataAttribute, purposeDataEnum.AD);
		const isExistMarketingScript = document.querySelector(`script[${ dataAttribute }="${ purposeDataEnum.AD }"]`);

		if (ad || adAnalytics) {
			if (gtmMarketingId && gtmMarketingId !== '!NOTSET!') {
				if (!isExistMarketingScript) {
					gtmMarketingScript.text = this.props.gtmCodeTemplate(gtmMarketingId);
					document.body.appendChild(gtmMarketingScript);
				}
			} else {
				console.error('GTM container for marketing tags is not set!');
			}
		} else if (isExistMarketingScript) {
			isExistMarketingScript.remove();
		}
	}

	isExcluded() {
		const {
			excludedSelectors,
		} = this.props;

		[ ...excludedSelectors ].find((excludedSelector) => {
			if (document.querySelector(excludedSelector)) {
				this.objects.isExcluded = true;
			}
			return this.objects.isExcluded;
		});
	}

	destructor() {
		this.unbindUniversalEvents();
		this.unbindPaneEvents();
		this.unbindSettingsEvents();
	}

}



// WEBPACK FOOTER //
// ./fe/web-3dliving/src/js/components/CookiesPolicy4/CookiesPolicy.js